import styled from 'styled-components';

const BackHyperLink = styled('a')`
  position: relative;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  background: transparent;
  margin: 0 16px;

  & :hover {
    text-decoration: none;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin: 0 32px;
    max-width: 1376px; // -64px (-32px on each side to position vertically to CVNA logo)
  }
`;

const BackLinkText = styled.h3`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #6d7184;
  cursor: inherit;
  margin: 0;
  display: flex;
  align-items: center;
`;

const BackLinkArrow = styled.span`
  margin-right: 4px;
  display: flex;
  align-items: center;
`;

export { BackHyperLink, BackLinkText, BackLinkArrow };
